import React from 'react';
import { CircularProgress, FormControlLabel } from '@material-ui/core';
import { AgGridReact } from 'ag-grid-react';
import Dialog from '../../components/Dialog/Dialog';
import { PrimaryButton, SecondaryButton, PrimaryCheckbox } from '../../components/AtomComponents';
import useQueryReview from './useQueryReview';
import { columnDefs, gridOptions, IProps } from './queryReviewUtils';
import './QueryReviewConfirmationDialog.scss';

const QueryReviewConfirmationDialog = ({
  environment, release, isOpen, onClose, onApprove, reviewQueries, queryData
}: IProps) => {
  const { acknowledged, setAcknowledged, handleApprove } = useQueryReview(isOpen, onClose, onApprove);

  const title = (
    <div className="px-query-review-dialog-header">
      <div className="header-left">
        <span className="dialog-title">Review Queries and Approve</span>
        <span className="dialog-meta">
          <span className="meta-item">Environment: <strong>{environment?.toUpperCase()}</strong></span>
          <span className="meta-item">Release: <strong>{release?.toUpperCase()}</strong></span>
          {queryData !== null && (
            <span className="meta-item">Total Queries: <strong>{queryData.length}</strong></span>
          )}
        </span>
      </div>
      {reviewQueries && (
        <SecondaryButton onClick={reviewQueries} size="small" className="refresh-btn">
          Refresh
        </SecondaryButton>
      )}
    </div>
  );

  let content;
  switch (queryData === null ? 'loading' : queryData.length === 0 ? 'empty' : 'data') {
    case 'loading':
      content = (
        <div className="px-query-review-loader-container">
          <CircularProgress />
          <h5>Fetching query details...</h5>
        </div>
      );
      break;
    case 'empty':
      content = (
        <div className="px-query-review-empty-container">
          <h5>No queries found for review.</h5>
        </div>
      );
      break;
    case 'data':
    default:
      content = (
        <div>
          <div className="ag-theme-alpine px-query-review-grid-container">
            <AgGridReact gridOptions={gridOptions} columnDefs={columnDefs} rowData={queryData || []} />
          </div>
          <div className="px-query-review-checkbox-container">
            <FormControlLabel
              control={<PrimaryCheckbox checked={acknowledged} onChange={(e) => setAcknowledged(e.target.checked)} name="acknowledge" />}
              label="I have reviewed and acknowledge the queries to be executed."
            />
          </div>
        </div>
      );
  }

  const actions = (
    <>
      <SecondaryButton onClick={onClose} className="px-query-review-dialog-actions">Cancel</SecondaryButton>
      <PrimaryButton onClick={handleApprove} disabled={!queryData || queryData.length === 0 || !acknowledged}>
        Approve
      </PrimaryButton>
    </>
  );

  return (
    <Dialog isDialogOpen={isOpen} closeDialog={onClose} title={title} content={content} actions={actions} maxWidth="lg" fullWidth />
  );
};

export default QueryReviewConfirmationDialog;
